import { render } from "./OnDutyEvent.vue?vue&type=template&id=322929e2"
import script from "./OnDutyEvent.vue?vue&type=script&lang=js"
export * from "./OnDutyEvent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__